/* eslint-disable no-underscore-dangle, import/no-named-as-default, import/no-named-as-default-member */
import { createSlice } from "@reduxjs/toolkit";
import {
  getAllInsuranceThunk,
  getInsuranceStatsThunk,
  getInsuranceByIdThunk,
  updateInsuranceThunk,
  deleteInsuranceThunk,
} from "redux/Thunks/Insurance";
import { resetStateThunk } from "redux/Thunks/Authentication";

const initialState = {
  loading: "pending",
  insuranceList: [],
  totalCount: 0,
  currentInsurance: null,
  stats: {
    totalPolicies: 0,
    totalGrossPremium: 0,
    totalNetPremium: 0,
    productWise: [],
    companyWise: [],
  },
};

export const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    addInsuranceToList(state, action) {
      if (action.payload) {
        state.insuranceList = [action.payload, ...state.insuranceList];
        state.totalCount += 1;
      }
    },
    updateInsuranceInList(state, action) {
      const updatedItem = action.payload;
      if (updatedItem?._id) {
        const index = state.insuranceList.findIndex((item) => item._id === updatedItem._id);
        if (index !== -1) {
          state.insuranceList[index] = { ...state.insuranceList[index], ...updatedItem };
        }
      }
    },
    removeInsuranceFromList(state, action) {
      state.insuranceList = state.insuranceList.filter((item) => item._id !== action.payload);
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
    setCurrentInsurance(state, action) {
      state.currentInsurance = action.payload;
    },
  },
  extraReducers: {
    [getAllInsuranceThunk.pending]: (state) => {
      if (state.insuranceList.length === 0) state.loading = "pending";
    },
    [getAllInsuranceThunk.fulfilled]: (state, { payload }) => {
      state.loading = "fulfilled";
      const resData = payload?.data?.data || payload?.data || payload;
      let list = [];
      let total = 0;

      if (resData && Array.isArray(resData.data)) {
        list = resData.data;
        total = resData.totalCount ?? list.length;
      } else if (Array.isArray(resData)) {
        list = resData;
        total = payload?.data?.totalCount ?? list.length;
      } else if (Array.isArray(payload?.data)) {
        list = payload.data;
        total = list.length;
      }

      state.totalCount = total;

      if (!payload?.byPassSlice && payload?.type === "add") {
        state.insuranceList = list;
      } else if (!payload?.byPassSlice && payload?.type === "append") {
        state.insuranceList.push(...list);
      } else {
        state.insuranceList = list;
      }
    },
    [getAllInsuranceThunk.rejected]: (state) => {
      state.loading = "rejected";
    },
    [getInsuranceStatsThunk.fulfilled]: (state, action) => {
      if (action.payload?.data) {
        state.stats = action.payload.data;
      }
    },
    [getInsuranceByIdThunk.fulfilled]: (state, action) => {
      if (action.payload?.data?.data) {
        state.currentInsurance = action.payload.data.data;
      } else if (action.payload?.data) {
        state.currentInsurance = action.payload.data;
      }
    },
    [updateInsuranceThunk.fulfilled]: (state, action) => {
      const updated = action.payload?.data?.data || action.payload?.data;
      if (updated?._id) {
        const index = state.insuranceList.findIndex((item) => item._id === updated._id);
        if (index !== -1) {
          state.insuranceList[index] = { ...state.insuranceList[index], ...updated };
        }
      }
    },
    [deleteInsuranceThunk.fulfilled]: (state, action) => {
      const deletedId = action.meta?.arg;
      if (deletedId) {
        state.insuranceList = state.insuranceList.filter((item) => item._id !== deletedId);
        state.totalCount = Math.max(0, state.totalCount - 1);
      }
    },
    [resetStateThunk.fulfilled]: () => initialState,
  },
});

export const {
  addInsuranceToList,
  updateInsuranceInList,
  removeInsuranceFromList,
  setCurrentInsurance,
} = insuranceSlice.actions;

export default insuranceSlice.reducer;
